/**
 * @generated SignedSource<<0160f124542506638266624c6da4e725>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type personalizedNotificationTemplatesTable_Refetch$variables = {
  after?: string | null;
  first?: number | null;
};
export type personalizedNotificationTemplatesTable_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesListFragment">;
};
export type personalizedNotificationTemplatesTable_Refetch = {
  response: personalizedNotificationTemplatesTable_Refetch$data;
  variables: personalizedNotificationTemplatesTable_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "personalizedNotificationTemplatesTable_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "personalizedNotificationTemplatesTable_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "PersonalizedNotificationTemplatesConnection",
                "kind": "LinkedField",
                "name": "GetPersonalizedNotificationTemplates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedNotificationTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedNotificationTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NotificationTemplate",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": (v2/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "personalizedNotificationTemplatesTable_GetPersonalizedNotificationTemplates",
                "kind": "LinkedHandle",
                "name": "GetPersonalizedNotificationTemplates"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationTemplate",
                "kind": "LinkedField",
                "name": "GetAvailableNotificationTemplates",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "93ef4499e41b22989aa375f144e53e90",
    "id": null,
    "metadata": {},
    "name": "personalizedNotificationTemplatesTable_Refetch",
    "operationKind": "query",
    "text": "query personalizedNotificationTemplatesTable_Refetch(\n  $after: String\n  $first: Int\n) {\n  ...personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesListFragment_2HEEH6\n}\n\nfragment createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment on Query {\n  Admin {\n    Notification {\n      GetAvailableNotificationTemplates {\n        key\n        title\n      }\n    }\n  }\n}\n\nfragment personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment on PersonalizedNotificationTemplate {\n  id\n  template {\n    key\n    title\n  }\n}\n\nfragment personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesListFragment_2HEEH6 on Query {\n  Admin {\n    Notification {\n      GetPersonalizedNotificationTemplates(first: $first, after: $after) {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            ...personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment\n            id\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n  ...createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment\n}\n"
  }
};
})();

(node as any).hash = "e89b36919c3b269d9740286ca913aab5";

export default node;
